import api from 'Application/api/api';

const getEpcPartnerOffers = (signal, configuration, searchQuery) => {
	const { page = 1, itemsPerPage = 20, sortBy = 'id', sortDirection = 'ASC' } = configuration;

	const params = {
		...configuration,
		query: searchQuery,
	};

	if (page) {
		params.page = page - 1;
	}

	if (itemsPerPage) {
		params.size = itemsPerPage;
	}

	if (sortBy && sortDirection) {
		params.sort = `${sortBy},${sortDirection}`;
	}

	return api.get('/epc-offers/partner/get-all', {
		params,
		signal,
	});
};

export default getEpcPartnerOffers;
